<template>
  <div class="p-4 bg-white shadow-lg rounded-lg flex items-center justify-between">
    <div class="flex items-center">
      <span class="text-4xl font-bold text-gray-800 mr-3">{{ overallRating }}</span>
      <div class="text-yellow-400 text-3xl flex">
        <FontAwesomeIcon
            v-for="(icon, index) in displayStarRating(overallRating)"
            :key="index"
            :icon="icon"
        />
      </div>
    </div>
    <div class="text-right">
      <p class="text-gray-600 text-sm">Based on {{ allReviews.length }} reviews</p>
      <p class="text-gray-600 text-sm">from various providers</p>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faStar as fasStar, faStarHalfAlt as fasStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as fasStarEmpty } from "@fortawesome/free-regular-svg-icons";

export default {
  name: 'ReviewBadge',
  components: {
    FontAwesomeIcon
  },
  props: ['overallRating', 'allReviews'],
  methods: {
    displayStarRating(rating) {
      const fullStars = Math.floor(rating);
      const hasHalfStar = rating % 1 !== 0;
      const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
      let stars = [];
      for (let i = 0; i < fullStars; i++) {
        stars.push(fasStar);
      }
      if (hasHalfStar) {
        stars.push(fasStarHalfAlt);
      }
      for (let i = 0; i < emptyStars; i++) {
        stars.push(fasStarEmpty);
      }
      return stars;
    }
  }
};
</script>

<style scoped>

</style>